"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LUX_LOYALTY_TIERS_CONFIG = exports.LUX_LOYALTY_TIERS_ORDER = void 0;
exports.LUX_LOYALTY_TIERS_ORDER = [
    'bronze',
    'silver',
    'gold',
    'platinum',
];
exports.LUX_LOYALTY_TIERS_CONFIG = {
    bronze: { displayName: 'Bronze' },
    silver: { displayName: 'Silver' },
    gold: { displayName: 'Gold' },
    platinum: { displayName: 'Platinum' },
};
